import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ColDef, RowClickedEvent, RowSelectedEvent } from 'ag-grid-community';
import { CrudbarComponent, jkBaseForm, minioAttachPath } from 'jk-service';
import { jkRestReturn, PageKind, UiModeType } from 'jk-service';
import { jkLib } from 'jk-service';
import { subscribeError } from 'jk-service';
import { CrudbarNavComponent } from 'jk-service';
import { entityState, JkEntityV2 } from 'jk-service';
import { JkqbeComponent, QbeConfig } from 'jk-service';
import { JkaggridComponent } from './jkaggrid/jkaggrid.component';
import { input, viewChild, computed, signal, output } from '@angular/core';
@Component({
  template: '',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    // Add necessary imports here when converting template
  ],
  host: {
    // Host bindings will be added here if needed
  },
})
export class jkSingleComponent extends jkBaseForm implements OnInit {
  crudbar!: CrudbarComponent;
  crudbarNav!: CrudbarNavComponent;
  //paginator!: MatPaginator;
  paginator = viewChild<MatPaginator>('paginator');
  //matSort!: MatSort; // TODO: 改 comReady
  //matSort  = viewChild<MatSort>('matsort');
  matSort = viewChild<MatSort>(MatSort);
  masterTabGroup!: MatTabGroup; // = viewChild<MatTabGroup>('masterTabGroup'); // TODO: 改 comReady
  tableDisplayedColumns: string[] = [];
  masterGrid!: JkaggridComponent;
  //private masterSrv: JkEntityV2 | any; //###
  masterSrv: JkEntityV2 | any; //###
  //private cdr: ChangeDetectorRef; 祖先已經有了
  get itemList(): any[] {
    if (this.masterSrv) return this.srv.itemList();
    else return [];
  }
  set itemList(value: any[]) {
    if (this.masterSrv) this.srv.setItemList(value);
    /*if (this.masterGrid) this.masterGrid.itemList = value
    else
      alert('set itemList this.masterGrid 未設定'); // jackie add
    */
  }

  get srv(): JkEntityV2 | any {
    return this.masterSrv;
  }
  set srv(srv: JkEntityV2 | any) {
    this.masterSrv = srv;
  }
  get columnDefs(): ColDef[] {
    if (this.masterSrv) return this.srv.columnDefs;
    else return [];
  }
  get isBrowse(): boolean {
    return this.srv.state === entityState.dsBrowse;
  }
  /*
  public _singleGridHeight = input<number>(this.screenHeight - 300);
  get singleGridHeight(): string {
    let r: string =
      'height: ' + jkLib.fixNumber(this._singleGridHeight) + 'px;';
    return r;
  }
    */

  masterEditPage!: any;
  detailProgramId: string = ''; // = this.programId+'-detail'; // ### modi,不要亂改
  detailLinkMasterFields: string = ''; // 'WL001=WD001';
  //detailPage!: jkSingleComponent; // ###
  //detailSrv!: any; // JkEntityV2;
  isDetailForm: boolean = false;
  get state(): entityState {
    if (this.masterSrv) return this.srv.state;
    else return entityState.dsBrowse;
  }
  get oldState(): entityState {
    return this.srv.oldState;
  }
  get oldItem(): any {
    return this.srv.oldItem;
  }
  get item(): any {
    if (!this.srv) return undefined;
    if (!this.srv.item) return undefined;

    return this.srv.item;
  }
  qbeConfig: QbeConfig = new QbeConfig();
  get gridStyle(): any {
    if (this.masterGrid && this.masterGrid.gridStyle)
      return this.masterGrid.gridStyle
    else
      //if(this.masterGrid){
      //  return this.masterGrid.gridStyle;
      //}else{
      return undefined;
    //}
  }
  set gridStyle(value: any) {
    if (this.masterGrid && this.masterGrid.gridStyle)
      this.masterGrid.gridStyle = value;
    //this._gridStyle = value;
  }
  // override cdr = inject(ChangeDetectorRef);
  override ngOnInit() {
    super.ngOnInit();
    this.setMasterService();

  }
  setMasterService() {
    if (this.masterSrv) {
      this.srv.programId = this.programId;
      this.srv.pageKind = this.pageKind;
      this.srv.afterContructor();
    }

  }
  readonly detailVisibleChange = output<boolean>();
  override onMasterTabChange($event: MatTabChangeEvent) {
    super.onMasterTabChange($event);
    this.detailVisibleChange.emit($event.tab.textLabel === '瀏覽');

  }

  constructor() {
    //super(injector);
    //constructor() {
    super(inject(Injector));
    if (this.masterSrv) {
      this.masterSrv
        .loadByHttpClient(this.srv.sqlWhere, this.srv.sqlOrder)
        .subscribe({
          next: (data: any) => {
            this.itemList = <any[]>data.obj;
          },
          error: (error: any) => {
            subscribeError(error);
          }
        });
    }
  }

  override async ngAfterViewInit(): Promise<void> {
    super.ngAfterViewInit();
    await this.constructorInit();
    this.srv.init();  // TODO: constructor 有跑.這裡再跑會重複. 但目前沒辦法
    setTimeout(() => {
      if (this.onFormReady) {
        this.onFormReady.emit(this);
      }
      //this.cdr.markForCheck(); // 手動觸發變更檢測以符合 zoneless 模式
      this.appRef.tick(); // 不用 cdr 了
    }, 50); // 50 太短會 RuntimeError: NG0100: ExpressionChangedAfterItHasBeenCheckedError
  }
  initGrid(grid: JkaggridComponent) {
    try {
      //grid.setProgramId(this.programId);
      // grid.programId = this.programId;// = this.programId; FIXME: input() signal問題
      grid.cbGridEdit = this.doUIGridEdit.bind(this);
      grid.cbEdit = this.doUIEdit.bind(this);
      grid.cbInsert = this.doUIInsert.bind(this);
      grid.cbDelete = this.doUIDelete.bind(this);
      grid.cbEditAndSave = this.doEditAndSave.bind(this);
    } catch (error) {
      alert('jkaggrid.initPage error:' + error);
    }
    grid.setGridColumns(this.masterSrv);

  }
  initCrudbar(crudbar: CrudbarComponent) {
    if (!crudbar) return;
    if (!this.crudbar) {
      console.log('jkSingle crudbar 設成 billForm的');
      this.crudbar = crudbar;
    }
    //  crudbar.cbQuery = this.doUIQuery.bind(this);
    crudbar.cbInsert = this.doUIInsert.bind(this);
    crudbar.cbEdit = this.doUIEdit.bind(this);
    crudbar.cbPost = this.doUIPost.bind(this);
    crudbar.cbCancel = this.doUICancel.bind(this);
    crudbar.cbDelete = this.doUIDelete.bind(this);
    crudbar.cbEditAndSave = this.doEditAndSave.bind(this);
    crudbar.cbHome = this.goHome.bind(this);
    crudbar.cbBack = this.goBack.bind(this);

    crudbar.cbConfirm = this.doConfirm.bind(this);
    crudbar.cbCancelConfirm = this.doCancelConfirm.bind(this);
    crudbar.cbVoid = this.doVoid.bind(this);
    crudbar.cbPrint = this.doPrint.bind(this);
    crudbar.cbAttach = this.doAttach.bind(this);
    crudbar.programId = this.programId;
    if (this.masterSrv) {
      this.srv.cbStateChanged = crudbar.onStateChanged.bind(crudbar); // ^_^ jackie 20250129 modi
    }

    this.initCrudbarLinkGrid(crudbar, this.masterGrid);
  }
  async doConfirm(params?: any): Promise<boolean> {
    let bool = false;
    // TODO:
    return bool;
  }
  async doCancelConfirm(params?: any): Promise<boolean> {
    let bool = false;
    // TODO:
    return bool;
  }
  async doVoid(params?: any): Promise<boolean> {
    let bool = false;
    // TODO:
    return bool;
  }
  async doPrint(params?: any): Promise<boolean> {
    let bool = false;
    // TODO:
    return bool;
  }
  async doAttach(params?: any): Promise<boolean> {
    let bool = false;
    // TODO:
    const item = this.item; // this.masterGrid.selectedItem;
    if (!jkLib.haveValue(item)) {
      alert('請先選單號!!!');
      return bool;
    }
    if (item.WB001 === '' || item.WB002 === '') {
      alert('請先選單號!!!');
    } else {
      const uploadHost = this.login.host;
      minioAttachPath(
        this.dialog,
        uploadHost,
        this.getImagePath(item),
      ).subscribe((result) => {
        if (result) {
          const files = result.rowsAffected;
          if (files) {
            if (typeof files === 'number') {
              // item.WB035 = item.WB035 + files; TODO:
            }
          }
        } //if
      });
    }

    return bool;
  }
  getImagePath(item: any): string {
    const path = `${item[this.srv.billType]}-${item[this.srv.billNo]}`;
    return path || 'unknown';
  }

  initCrudbarNav(crudbarNav: CrudbarNavComponent) {
    if (!crudbarNav) return;
    if (!this.crudbarNav) {
      console.log('jkSingle crudbarNav 設成 billForm的');
      this.crudbarNav = crudbarNav;
    }
    //  crudbar.cbQuery = this.doUIQuery.bind(this);
    crudbarNav.cbInsert = this.doUIInsert.bind(this);
    crudbarNav.cbEdit = this.doUIEdit.bind(this);
    crudbarNav.cbPost = this.doUIPost.bind(this);
    crudbarNav.cbCancel = this.doUICancel.bind(this);
    crudbarNav.cbDelete = this.doUIDelete.bind(this);
    crudbarNav.cbEditAndSave = this.doEditAndSave.bind(this);
    crudbarNav.cbHome = this.goHome.bind(this);
    crudbarNav.cbBack = this.goBack.bind(this);
    crudbarNav.programId = this.programId;
    if (this.masterSrv) {
      this.srv.cbStateChanged = crudbarNav.onStateChanged.bind(crudbarNav); // ^_^ jackie 20250129 modi
    }

    this.initCrudbarLinkGrid(crudbarNav, this.masterGrid);
  }
  initCrudbarLinkGrid(crudbar: CrudbarNavComponent, grid: JkaggridComponent) {
    if (!crudbar) return;
    if (!grid) return;
    crudbar.cbFirst = grid.onFirstRow.bind(grid);
    crudbar.cbPrevious = grid.onPreviousRow.bind(grid);
    crudbar.cbNext = grid.onNextRow.bind(grid);
    crudbar.cbLast = grid.onLastRow.bind(grid);
  }
  onBeforeQbe() {
    this.power.checkPower(this.programId, this.login, 'query');
    this.qbeConfig.masterSrv = this.masterSrv;
  }
  afterGridReady($event: JkaggridComponent) {
    // ###
    this.masterGrid = $event;

    this.masterGrid.initPage(this.gridInitOpt, this.masterSrv);
    this.initGrid(this.masterGrid);
    //this.setGridColumns(this.columnDefs,this.masterSrv,this.masterGrid,this.columnModi);
    //this.setGridColumns(this.masterSrv,this.masterGrid);
    //if(this.crudbar)
    //  this.crudbar.initGrid(this.masterGrid);
    //if (this.masterSrv) {
    //  this.masterGrid.setGridColumns(this.masterSrv);
    //this.masterGrid.itemList = this.srv.itemList();
    //}
    this.initTabGroup();
    if (this.crudbar) {
      this.initCrudbarLinkGrid(this.crudbar, this.masterGrid);
    }
  }

  override checkAllInit(form: any): boolean {
    // FIXME: 可能都沒執行
    let result = super.checkAllInit(form);
    return result;
  }
  override doUIQuery(e?: any) {
    super.doUIQuery(e);
    //this.doUIRefresh(e);
    this.doMyQbe();
    if (this.uiMode === UiModeType.tab) {
      this.masterTabGroupIndex = 0;
      /*this.masterTabGroup._tabs.forEach((tab, index) => {
          tab.disabled = false;
        });*/
    }
  }
  doMyQbe() {
    this.onBeforeQbe();
    this.dialog
      .open(JkqbeComponent, this.initConfig(this.qbeConfig)) //###
      .afterClosed()
      .subscribe({
        next: (data: any) => {
          if (!data) return;
          if (!data.result) return;

          let where = data.sqlWhere + this.qbeConfig.addWhere;
          let order = data.sqlOrder;
          this.directQuery(where, order);
          /*this.srv.loadByHttpClient(where, order).subscribe((data:any) => {
        this.srv.itemList = data.obj;
        this.doRefresh();
      });*/
        },
        error: (error: any) => {
          subscribeError(error);
        }
      });
  }
  override getLookup() {
    super.getLookup();
    if (!this.gridInitOpt.sortField)
      this.showAlert('未設定 gridInitOpt.sortField');
    if (this.pageKind === PageKind.master) {
      this.srv.sqlOrder = ` ORDER BY ${this.gridInitOpt.sortField}  ${this.gridInitOpt.sort} `;
    }
  }
  async constructorInit(): Promise<void> {
    // 注意: 建檔層不要再跑 setFormOpt2
    if (this.masterSrv)
      this.srv.cdr = this.cdr;
    this.setEntityEvent(this.masterSrv); // ###
    /* 一律在 個案層constructor自行
    if (this.pageKind === PageKind.master) {
      await this.setFormOpt2(this.title); //###
    }*/
    this.getLookup(); // ###
  }
  /**
   *
   * @param where 查詢條件, ex: ` AND 2=2 `
   * @param order 排序,ex: 'ORDER BY PROGID'
   */
  async directQuery(where: string, order: string) {
    if (this.onBeforeQuery)
      this.onBeforeQuery(this.item, this.ret);
    this.srv.loadByHttpClient(where, order).subscribe({
      next: (data: any) => {
        setTimeout(async () => {
          this.srv.setItemList(data.obj);
          this.masterGrid.setItemList(data.obj);
          //this.doUIRefresh(entityState.dsBrowse, this.srv.item);
          await this.doRefresh();
          //this.cdr.detectChanges();
        });
      },
      error: (error: any) => {
        subscribeError(error);
      }
    });
  }
  override doUIRefresh(state: entityState, item: any): void {
    super.doUIRefresh(state, item);
    if (this.masterGrid) {
      this.masterGrid.refresh();
      this.masterGrid.doCrud(state, item);
    }
    //if(this.tableSrv)
    //  this.tableSrv.doRefresh(this.srv.itemList);// 目前沒有使用
  }
  override async doRefresh(): Promise<void> {
    super.doRefresh();
    if (this.masterSrv) {
      // ^_^ jackie 20250325 add
      const list: any[] = await this.srv.loadData(); // ^_^ jackie 20250325 add
      if(list && !this.item){
        try {
        if(list.length > 0){
          this.item.set(list[0]);
        }
        } catch (error: any) {

        }
      }
    }
    this.doUIRefresh(entityState.dsBrowse, this.item);
    if (this.onAfterScroll) {
      const bool = jkLib.isEmpty(this.item);
      if (!bool) {
        this.onAfterScroll(this.item, this.ret);
      }
    }
  }
  cbBillAfterScroll?: (item: any, ret: jkRestReturn) => void;
  cbBillDelete?: (params: any, ret: jkRestReturn) => Promise<boolean>;
  cbBillStateChanged!: (state: entityState) => void;
  cbBillPost?: (params?: any) => Promise<boolean>;
  cbBillCancel?: (item: any) => boolean;
  cbBillCancelEdit?: (bool: boolean) => void;
  cbBillRefresh?: () => void;
  cbGetMasterData?: () => any;

  override onAfterScroll(item: any, ret: jkRestReturn): void {
    super.onAfterScroll(item, ret);// 有接到 jkentity
    if (this.cbBillAfterScroll) {
      if (!this.isEmpty(item)) { //
        this.cbBillAfterScroll(item, ret);
      }
    };
  }
  override async doUIInsert(e?: any): Promise<void> {
    super.doUIInsert(e);
    this.doUIModeChange(entityState.dsInsert);
  }
  override async doEditAndSave($event: any): Promise<boolean> {
    let bool = await super.doEditAndSave($event);
    if (this.masterSrv) bool = await this.srv.editAndSave($event);
    if (bool) {
      if (this.crudbar) {
        this.crudbar.onStateChanged(entityState.dsBrowse);
      }
    }
    //this.doUIModeChange(entityState.dsEdit);
    return bool;
  }
  override doUIGridEdit($event: any) {
    super.doUIGridEdit($event);
    if (this.pageKind === PageKind.master) {
      if (this.crudbar) {
        if (this.crudbar.onStateChanged) {
          this.crudbar.onStateChanged(entityState.dsEdit);
        } else {
          console.error('jkSingle crudbar.onStateChanged is undefined');
        }
      } else {
        console.info('jkSingle crudbar is undefined');
      }
    }
    if (this.masterSrv) this.srv.doEdit($event);

    //this.doUIModeChange(entityState.dsEdit);
  }
  /* 祖先有了
  onAfterCancel?: (item: any, ret: jkRestReturn) => void;
  onAfterClose?: (item: any, ret: jkRestReturn) => void;
  onAfterDelete?: (e: any, ret: jkRestReturn) => void;
  onAfterEdit?: (item: any, ret: jkRestReturn) => void;
  onAfterInsert?: (item: any, ret: jkRestReturn) => void;
  onAfterOpen?: (item: any, ret: jkRestReturn) => void;
  onAfterPost?: (e: any, ret: jkRestReturn) => Promise<void>;
  onAfterQuery?: (e: any, ret: jkRestReturn) => void;
  onAfterRefresh?: (item: any, ret: jkRestReturn) => void;
  onAfterScroll?: (item: any, ret: jkRestReturn) => void;

  onBeforeCancel?: (item: any, ret: jkRestReturn) => void;
  onBeforeClose?: (item: any, ret: jkRestReturn) => void;
  onBeforeDelete?: (e: any, ret: jkRestReturn) => void;
  onBeforeEdit?: (item: any, ret: jkRestReturn) => void;
  onBeforeInsert?: (item: any, ret: jkRestReturn) => void;
  onBeforeOpen?: (e: any, ret: jkRestReturn) => void;
  onBeforePost?: (e: any, ret: jkRestReturn) => void;
  onBeforeQuery?: (e: any, ret: jkRestReturn) => void;
  onBeforeRefresh?: (e: any, ret: jkRestReturn) => void;
  onBeforeScroll?: (e: any, ret: jkRestReturn) => void;
  */
  async doMyDelete(params: any, ret: jkRestReturn) {
    // 只刪 master, detail hand 由 BillDelete
    if (this.masterSrv) {
      let r = await this.srv.doDelete(params, true);
      ret.assign(r);
      if (ret.result) {
        if (this.masterGrid) {
          let bool = await this.masterGrid.gridSrv.delete(this.item);
        }
      }
    }
  }
  override async onDeleting(params: any, ret: jkRestReturn) {
    await super.onDeleting(params, ret);
    //ret.result = await this.billSrv.doMyDelete();
    /* 一律由 doUIDelete 呼叫 cbBillDelete
    if (this.cbBillDelete) {
      ret.result = await this.cbBillDelete(params, ret);
    } else {
      await this.doMyDelete(params, ret);
    }*/
  }

  override async doUIDelete(params?: any): Promise<boolean> {
    let bool = await super.doUIDelete(params);
    if (this.cbBillDelete && (this.pageKind === PageKind.master)) {
      bool = await this.cbBillDelete(params, this.ret);
    } else {
      if (this.pageKind !== PageKind.master) {
        await this.doMyDelete(params, this.ret);
        bool = this.ret.result;
      }
    }
    return bool;
  }

  override async doUIEdit(itemData?: any) {
    super.doUIEdit();
    await this.doUIModeChange(entityState.dsEdit);
  }
  override async doUIPost(params?: any): Promise<boolean> {
    if (!params) {
      params = this.item;
    }
    let bool = await super.doUIPost(params);
    console.log('jkSingle.doUIPost bool:', bool);
    if (bool) {
      bool = await this.srv.doMyOk(); // billSrv.doMyOk();
      console.log('jkSingle.doUIPost-doMyOk bool:', bool);
    }
    if (bool) {
      await this.doUIModeChange(entityState.dsBrowse);
      console.log('jkSingle.doUIPost.doUIModeChange bool:', bool);
      this.doUIRefresh(entityState.dsBrowse, this.item);
    }
    return bool;
  }
  override doUICancel(item?: any): boolean {
    let bool = super.doUICancel(item);
    console.log('jkSingle.doUICancel bool:', bool);
    if (bool) {
      bool = this.srv.doCancel();
      console.log('jkSingle.doUICancel.doCancel bool:', bool);
    }
    if (bool) {
      this.doUIModeChange(entityState.dsBrowse);
      console.log('jkSingle.doUICancel.doUIModeChange bool:', bool);
    }
    return bool;
  }
  async doUIModeChange(state: entityState): Promise<void> {
    //jkDetailform 要同步改 doUIModeChange
    //debugger;
    console.log('doUIModeChange');
    if (this.crudbar) {
      this.crudbar.onStateChanged(state);
    } else {
      console.error('jkSingle crudbar is undefined');
    }
    if (this.uiMode === UiModeType.dialog) {
      if (state === entityState.dsBrowse) {
        //this.crudbar.onStateChanged(entityState.dsBrowse);
      } else {
        await this.showEdit(state);
      }
    }

  }

  async onBeforeShowEdit(state: entityState): Promise<void> {

  }

  //showEdit(isInsert: boolean = false) {
  async showEdit(state: entityState) {
    await this.onBeforeShowEdit(state);
    if (!this.masterEditPage) {
      const msg = 'jkSingle masterEditPage is undefined';
      console.error(msg);
      this.snackBar.open(msg, '關閉', { duration: 2000 });
      return;
    }
    const restoreChangeDetection = () => {
      window.setTimeout(() => {
        this.cdr.reattach();
        this.cdr.detectChanges();
      });
    };
    this.cdr.detach();
    try {
      if (state === entityState.dsInsert) {
        if (this.pageKind !== PageKind.master) {
          //const masterItem = this.cbGetMasterData?.();
          // this.srv.linkMaster(
          //(this.srv as JkEntityV2).setLinkKeyObjFromMasterItem(masterItem);
        }
        await this.srv.doInsert();
      }
      if (state === entityState.dsEdit) {
        this.srv.doEdit(this.srv.item); // ###
      }
      this.dialog
        //.open(this.masterEditPage, this.initConfig(this.masterSrv)) //###
        .open(this.masterEditPage, this.initConfig(this)) //###  // ^_^ jackie 20250325 modi
        .afterClosed()
        .subscribe({
          next: async (result: any) => {
            if (result) {
              if (this.masterGrid) {
                if (state === entityState.dsInsert) {
                  //this.masterGrid.gridApi.applyTransaction({ add: [this.srv.item] });
                  // await this.masterGrid.doInsert(this.srv.item); // ^_^ jackie 避免重複顯示，因 item 已在 srv.itemList 中
                }
                if (state === entityState.dsEdit) {
                  // this.masterGrid.doUpdate(this.srv.item); // ^_^ jackie 避免重複顯示，因 item 已在 srv.itemList 中
                }
              }
            }
            restoreChangeDetection();
          },
          error: (error: any) => {
            restoreChangeDetection();
            subscribeError(error);
          }
        });
    } catch (error: any) {
      restoreChangeDetection();
      subscribeError(error);
    }
  }
  doOpenDetail(item: any) {
    //this.isDetailForm = true;
    if (this.pageKind === PageKind.master) {
      // 防呆
      return;
    }
    const bool = this.isEmpty(item);
    if (bool) {
      alert('jkSingle:請先選一筆主檔記錄!(主檔無KEY值)');
      return;
    };
    //let detailSrv = this.masterSrv;
    if (this.masterSrv) {
      this.masterSrv
        .doOpenDetail(item, '')
        /*.subscribe((data: any) => {
          this.this.srv.itemList = data.obj;
          this.doUIRefresh(entityState.dsBrowse, this.this.srv.item);
        });*/
        .subscribe({
          next: (value: any) => {
            setTimeout(() => {
              this.srv.setItemList(value.obj);
              this.doUIRefresh(entityState.dsBrowse, this.srv.item);
            }, 5);
          },
          error: (error: any) => {
            // 處理錯誤
            alert('單身資料載入錯誤(doOpenDetail):' + error.message);
            setTimeout(() => {
              this.srv.setItemList([]);
            });
          },
          complete: () => {
            // 完成時執行（可選）
          },
        });
    } else {
      this.showAlert('this.masterSrv is not defined');
    }
  }
  /**
   * 由jkaggrid emit 發出來
   * @param $event
   */
  agRowClicked($event: RowClickedEvent<any, any>) {
    this.srv.item = $event.data; // 會產生afterScroll
  }
  agRowSelected($event: RowSelectedEvent<any, any>) {
    // 會跑兩次. 一次是選取, 一次是取消選取
    console.log('jkSingle.agRowSelected', $event.data);
    const selected = this.masterGrid.gridApi.getSelectedRows();
    if (selected.length === 0) {
      return;
    }
    this.srv.item = selected[0];
  }
  override doComReady($e: any, comName: string): void {
    super.doComReady($e, comName);
    if (comName === 'crudbar-nav') {
      this.crudbar = $e;
      this.initCrudbarNav(this.crudbar);
    }
    if (comName === 'crudbar') {
      this.crudbar = $e;
      this.initCrudbar(this.crudbar);
    }

    if (comName === 'masterTabGroup') {
      this.masterTabGroupCom = $e;
    }
  }
  override setMasterHaveDetail(haveDetail: boolean) {
    super.setMasterHaveDetail(haveDetail);
    if (haveDetail) {
      if (this.crudbar) this.crudbar.visible.set(false);
      if (this.masterGrid) this.masterGrid.heightChange(300); // this.masterGrid.defaultHeight()
    }
  }
  setMasterHaveHand(haveHand: boolean) {
    //super.setMasterHaveHand(haveHand);
    if (haveHand) {
      this.crudbar.visible.set(false);
      this.masterGrid.heightChange(300); // this.masterGrid.defaultHeight()
    }

  }
}
